/** The body the backend's error translator returns: a code, a message for the user and sometimes a detail. */
export interface ApiErrorBody {
    code?: string;
    message?: string;
    detail?: string;
}

/** The error body of a rejected RTK Query call, or undefined when the error carries none. */
export function readApiErrorBody(error: unknown): ApiErrorBody | undefined {
    if (error && typeof error === 'object' && 'data' in error) {
        const data = (error as { data?: unknown }).data;
        return data && typeof data === 'object' ? (data as ApiErrorBody) : undefined;
    }
    return undefined;
}
